import { createAction } from "@reduxjs/toolkit";
import { AUTHENTICATION_FEATURE_KEY, BLUEM_REGISTRATION_FEATURE_KEY, SOCIAL_NETWORK_FEATURE_KEY, PROVINCES_FEATURE_KEY, GVIVE_VALIDATION_FEATURE_KEY } from "./shared-authentication-feature-keys.js";
const getSignInStart = createAction(`${AUTHENTICATION_FEATURE_KEY}/getSignInStart`);
const clearConfirmationError = createAction(`${AUTHENTICATION_FEATURE_KEY}/clearConfirmationError`);
const clearSignInData = createAction(`${AUTHENTICATION_FEATURE_KEY}/clearSignInData`);
const clearSignInError = createAction(`${AUTHENTICATION_FEATURE_KEY}/clearSignInError`);
const getSignInSuccess = createAction(`${AUTHENTICATION_FEATURE_KEY}/getSignInSuccess`);
const authorizeBluemToken = createAction(`${BLUEM_REGISTRATION_FEATURE_KEY}/authorizeBluemToken`);
const loginCustomer = (customer) => ({
  type: getSignInStart.type,
  payload: customer
});
const getSocialNetworkRegistrationLinkStart = createAction(`${SOCIAL_NETWORK_FEATURE_KEY}/getSocialNetworkRegistrationLinkStart`);
const socialMethodRegistrationLinkRequst = (payload) => ({
  type: getSocialNetworkRegistrationLinkStart.type,
  payload
});
const getProvincesStart = createAction(`${PROVINCES_FEATURE_KEY}/getProvincesStart`);
const fetchProvinces = () => ({
  type: getProvincesStart.type
});
const getGviveValidationFailure = createAction(`${GVIVE_VALIDATION_FEATURE_KEY}/getGviveValidationFailure`);
export {
  authorizeBluemToken,
  clearConfirmationError,
  clearSignInData,
  clearSignInError,
  fetchProvinces,
  getGviveValidationFailure,
  getProvincesStart,
  getSignInStart,
  getSignInSuccess,
  getSocialNetworkRegistrationLinkStart,
  loginCustomer,
  socialMethodRegistrationLinkRequst
};
